export default __webpack_public_path__ + "media/zurb/img/bryan/thumbs/8-86203ea3341c2c5a69aa1ab849007b13.png";